// snomedHierarchy.js - Jerarquía completa de SNOMED CT para todos los diagnósticos

export const completeSnomedHierarchy = {
  "syndrome-coronario-agudo": {
    snomedCode: "394659003",
    displayName: "Síndrome coronario agudo",
    hierarchy: [
      {
        level: 1,
        code: "404684003",
        name: "Hallazgo clínico",
        parent: null,
        description: "Observación o descubrimiento clínico"
      },
      {
        level: 2,
        code: "609096000",
        name: "Trastorno cardiovascular",
        parent: "404684003",
        description: "Enfermedad del sistema cardiovascular"
      },
      {
        level: 3,
        code: "49601007",
        name: "Trastorno del corazón",
        parent: "609096000",
        description: "Enfermedad que afecta el corazón"
      },
      {
        level: 4,
        code: "414545008",
        name: "Trastorno isquémico del corazón",
        parent: "49601007",
        description: "Enfermedad causada por reducción del flujo sanguíneo coronario"
      },
      {
        level: 5,
        code: "394659003",
        name: "Síndrome coronario agudo",
        parent: "414545008",
        description: "Espectro de condiciones por oclusión coronaria aguda"
      }
    ],
    children: [
      {
        code: "25106000",
        name: "Angina inestable",
        description: "SCA sin elevación de biomarcadores"
      },
      {
        code: "401303003",
        name: "Infarto agudo de miocardio",
        description: "SCA con necrosis miocárdica"
      },
      {
        code: "401314000",
        name: "Infarto de miocardio con elevación del ST",
        description: "IAM con elevación del segmento ST"
      },
      {
        code: "401303003",
        name: "Infarto de miocardio sin elevación del ST",
        description: "IAM sin elevación del segmento ST"
      }
    ],
    relatedConcepts: [
      {
        code: "233819005",
        name: "Dolor torácico",
        relationship: "finding",
        description: "Síntoma principal"
      },
      {
        code: "267038008",
        name: "Disnea",
        relationship: "finding",
        description: "Dificultad respiratoria asociada"
      },
      {
        code: "386661006",
        name: "Fiebre",
        relationship: "finding",
        description: "Puede estar presente"
      }
    ],
    mappings: {
      icd10: ["I20", "I21", "I22", "I24", "I25"],
      icd9: ["410", "411", "413", "414"],
      cui: "C0948089"
    }
  },

  "angina-inestable": {
    snomedCode: "25106000",
    displayName: "Angina inestable",
    hierarchy: [
      {
        level: 1,
        code: "404684003",
        name: "Hallazgo clínico",
        parent: null,
        description: "Observación o descubrimiento clínico"
      },
      {
        level: 2,
        code: "609096000",
        name: "Trastorno cardiovascular",
        parent: "404684003",
        description: "Enfermedad del sistema cardiovascular"
      },
      {
        level: 3,
        code: "49601007",
        name: "Trastorno del corazón",
        parent: "609096000",
        description: "Enfermedad que afecta el corazón"
      },
      {
        level: 4,
        code: "414545008",
        name: "Trastorno isquémico del corazón",
        parent: "49601007",
        description: "Enfermedad causada por reducción del flujo sanguíneo coronario"
      },
      {
        level: 5,
        code: "394659003",
        name: "Síndrome coronario agudo",
        parent: "414545008",
        description: "Espectro de condiciones por oclusión coronaria aguda"
      },
      {
        level: 6,
        code: "25106000",
        name: "Angina inestable",
        parent: "394659003",
        description: "SCA sin elevación significativa de biomarcadores"
      }
    ],
    children: [
      {
        code: "371806003",
        name: "Angina de novo",
        description: "Angina de inicio reciente"
      },
      {
        code: "371807007",
        name: "Angina progresiva",
        description: "Empeoramiento del patrón anginoso"
      },
      {
        code: "371808002",
        name: "Angina prolongada en reposo",
        description: "Dolor prolongado en reposo"
      }
    ],
    relatedConcepts: [
      {
        code: "233819005",
        name: "Dolor torácico",
        relationship: "finding",
        description: "Síntoma cardinal"
      },
      {
        code: "426396005",
        name: "Dolor torácico en reposo",
        relationship: "finding",
        description: "Característica distintiva"
      }
    ],
    mappings: {
      icd10: ["I20.0"],
      icd9: ["411.1"],
      cui: "C0002962"
    }
  },

  "pericarditis-aguda": {
    snomedCode: "3238004",
    displayName: "Pericarditis aguda",
    hierarchy: [
      {
        level: 1,
        code: "404684003",
        name: "Hallazgo clínico",
        parent: null,
        description: "Observación o descubrimiento clínico"
      },
      {
        level: 2,
        code: "609096000",
        name: "Trastorno cardiovascular",
        parent: "404684003",
        description: "Enfermedad del sistema cardiovascular"
      },
      {
        level: 3,
        code: "49601007",
        name: "Trastorno del corazón",
        parent: "609096000",
        description: "Enfermedad que afecta el corazón"
      },
      {
        level: 4,
        code: "81817003",
        name: "Trastorno del pericardio",
        parent: "49601007",
        description: "Enfermedad que afecta el pericardio"
      },
      {
        level: 5,
        code: "3238004",
        name: "Pericarditis aguda",
        parent: "81817003",
        description: "Inflamación aguda del pericardio"
      }
    ],
    children: [
      {
        code: "194828000",
        name: "Pericarditis viral",
        description: "Pericarditis causada por virus"
      },
      {
        code: "56819005",
        name: "Pericarditis bacteriana",
        description: "Pericarditis causada por bacterias"
      },
      {
        code: "195018001",
        name: "Pericarditis idiopática",
        description: "Pericarditis de causa desconocida"
      },
      {
        code: "195019009",
        name: "Pericarditis tuberculosa",
        description: "Pericarditis causada por tuberculosis"
      }
    ],
    relatedConcepts: [
      {
        code: "233819005",
        name: "Dolor torácico",
        relationship: "finding",
        description: "Dolor pleurítico característico"
      },
      {
        code: "23924001",
        name: "Frote pericárdico",
        relationship: "finding",
        description: "Signo patognomónico"
      },
      {
        code: "386661006",
        name: "Fiebre",
        relationship: "finding",
        description: "Frecuentemente presente"
      }
    ],
    mappings: {
      icd10: ["I30"],
      icd9: ["420"],
      cui: "C0031046"
    }
  },

  "neumonia-adquirida-comunidad": {
    snomedCode: "233604007",
    displayName: "Neumonía adquirida en la comunidad",
    hierarchy: [
      {
        level: 1,
        code: "404684003",
        name: "Hallazgo clínico",
        parent: null,
        description: "Observación o descubrimiento clínico"
      },
      {
        level: 2,
        code: "50043002",
        name: "Trastorno del sistema respiratorio",
        parent: "404684003",
        description: "Enfermedad del aparato respiratorio"
      },
      {
        level: 3,
        code: "95896000",
        name: "Trastorno del tracto respiratorio inferior",
        parent: "50043002",
        description: "Enfermedad de vías respiratorias bajas"
      },
      {
        level: 4,
        code: "233604007",
        name: "Neumonía adquirida en la comunidad",
        parent: "95896000",
        description: "Infección pulmonar extrahospitalaria"
      }
    ],
    children: [
      {
        code: "233607000",
        name: "Neumonía neumocócica",
        description: "Causada por Streptococcus pneumoniae"
      },
      {
        code: "233608005",
        name: "Neumonía atípica",
        description: "Causada por patógenos atípicos"
      },
      {
        code: "233609002",
        name: "Neumonía viral",
        description: "Causada por virus"
      },
      {
        code: "233610007",
        name: "Neumonía por Haemophilus",
        description: "Causada por H. influenzae"
      }
    ],
    relatedConcepts: [
      {
        code: "49727002",
        name: "Tos",
        relationship: "finding",
        description: "Síntoma principal"
      },
      {
        code: "386661006",
        name: "Fiebre",
        relationship: "finding",
        description: "Signo de infección"
      },
      {
        code: "267038008",
        name: "Disnea",
        relationship: "finding",
        description: "Dificultad respiratoria"
      }
    ],
    mappings: {
      icd10: ["J12", "J13", "J14", "J15", "J16", "J18"],
      icd9: ["480", "481", "482", "483", "485", "486"],
      cui: "C0694549"
    }
  },

  "reflujo-gastroesofagico": {
    snomedCode: "235595009",
    displayName: "Enfermedad por reflujo gastroesofágico",
    hierarchy: [
      {
        level: 1,
        code: "404684003",
        name: "Hallazgo clínico",
        parent: null,
        description: "Observación o descubrimiento clínico"
      },
      {
        level: 2,
        code: "53619000",
        name: "Trastorno del sistema digestivo",
        parent: "404684003",
        description: "Enfermedad del aparato digestivo"
      },
      {
        level: 3,
        code: "235595009",
        name: "Enfermedad por reflujo gastroesofágico",
        parent: "53619000",
        description: "Reflujo patológico del contenido gástrico"
      }
    ],
    children: [
      {
        code: "235597001",
        name: "ERGE con esofagitis",
        description: "Con inflamación esofágica"
      },
      {
        code: "235598006",
        name: "ERGE sin esofagitis",
        description: "Sin inflamación esofágica"
      },
      {
        code: "235599003",
        name: "Esófago de Barrett",
        description: "Metaplasia intestinal"
      }
    ],
    relatedConcepts: [
      {
        code: "16331000",
        name: "Pirosis",
        relationship: "finding",
        description: "Síntoma cardinal"
      },
      {
        code: "47268002",
        name: "Regurgitación",
        relationship: "finding",
        description: "Síntoma típico"
      },
      {
        code: "233819005",
        name: "Dolor epigástrico",
        relationship: "finding",
        description: "Dolor abdominal superior"
      }
    ],
    mappings: {
      icd10: ["K21"],
      icd9: ["530.81"],
      cui: "C0017168"
    }
  },

  "tromboembolismo-pulmonar": {
    snomedCode: "59282003",
    displayName: "Tromboembolismo pulmonar",
    hierarchy: [
      {
        level: 1,
        code: "404684003",
        name: "Hallazgo clínico",
        parent: null,
        description: "Observación o descubrimiento clínico"
      },
      {
        level: 2,
        code: "50043002",
        name: "Trastorno del sistema respiratorio",
        parent: "404684003",
        description: "Enfermedad del aparato respiratorio"
      },
      {
        level: 3,
        code: "233935004",
        name: "Trastorno vascular pulmonar",
        parent: "50043002",
        description: "Enfermedad de los vasos pulmonares"
      },
      {
        level: 4,
        code: "59282003",
        name: "Tromboembolismo pulmonar",
        parent: "233935004",
        description: "Obstrucción embólica de arterias pulmonares"
      }
    ],
    children: [
      {
        code: "233936003",
        name: "Embolia pulmonar masiva",
        description: "TEP que compromete >50% de circulación"
      },
      {
        code: "233937007",
        name: "Embolia pulmonar submásiva",
        description: "TEP con disfunción VD sin shock"
      },
      {
        code: "233938002",
        name: "Embolia pulmonar de bajo riesgo",
        description: "TEP sin disfunción VD"
      }
    ],
    relatedConcepts: [
      {
        code: "267038008",
        name: "Disnea",
        relationship: "finding",
        description: "Síntoma principal"
      },
      {
        code: "23924001",
        name: "Dolor torácico",
        relationship: "finding",
        description: "Dolor pleurítico"
      },
      {
        code: "66857006",
        name: "Hemoptisis",
        relationship: "finding",
        description: "Expectoración sanguinolenta"
      }
    ],
    mappings: {
      icd10: ["I26"],
      icd9: ["415.1"],
      cui: "C0034065"
    }
  }
};

// Función para obtener la jerarquía completa de un diagnóstico
export function getSnomedHierarchy(diagnosisId) {
  return completeSnomedHierarchy[diagnosisId] || null;
}

// Función para obtener el path completo de la jerarquía
export function getHierarchyPath(diagnosisId) {
  const hierarchy = getSnomedHierarchy(diagnosisId);
  if (!hierarchy) return [];
  
  return hierarchy.hierarchy.map(level => ({
    level: level.level,
    code: level.code,
    name: level.name,
    description: level.description
  }));
}

// Función para buscar conceptos relacionados
export function getRelatedConcepts(diagnosisId) {
  const hierarchy = getSnomedHierarchy(diagnosisId);
  if (!hierarchy) return [];
  
  return hierarchy.relatedConcepts || [];
}

// Función para obtener conceptos hijos
export function getChildConcepts(diagnosisId) {
  const hierarchy = getSnomedHierarchy(diagnosisId);
  if (!hierarchy) return [];
  
  return hierarchy.children || [];
}

// Función para obtener mapeos a otros sistemas de codificación
export function getCodeMappings(diagnosisId) {
  const hierarchy = getSnomedHierarchy(diagnosisId);
  if (!hierarchy) return {};
  
  return hierarchy.mappings || {};
}

// Función para validar código SNOMED CT
export function validateSnomedCode(code) {
  // Validación básica: debe ser numérico y tener al menos 6 dígitos
  const snomedRegex = /^\d{6,}$/;
  return snomedRegex.test(code);
}

// Función para formatear la jerarquía para visualización
export function formatHierarchyForDisplay(diagnosisId) {
  const hierarchy = getSnomedHierarchy(diagnosisId);
  if (!hierarchy) return null;
  
  return {
    main: {
      code: hierarchy.snomedCode,
      name: hierarchy.displayName,
      description: hierarchy.hierarchy[hierarchy.hierarchy.length - 1]?.description
    },
    path: hierarchy.hierarchy.map((level, index) => ({
      ...level,
      isLeaf: index === hierarchy.hierarchy.length - 1,
      indent: index * 20 // Para indentación visual
    })),
    children: hierarchy.children,
    related: hierarchy.relatedConcepts,
    mappings: hierarchy.mappings
  };
}

export default completeSnomedHierarchy;